import { render, staticRenderFns } from "./DocumentAIP.vue?vue&type=template&id=169f2b1d&scoped=true&"
import script from "./DocumentAIP.vue?vue&type=script&lang=js&"
export * from "./DocumentAIP.vue?vue&type=script&lang=js&"
import style0 from "./DocumentAIP.vue?vue&type=style&index=0&id=169f2b1d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "169f2b1d",
  null
  
)

export default component.exports